import { Amount } from '@ui/uikit/components/common/Amount';
import { Typography } from '@ui/uikit/components/common/Typography';

import type { ScoreProps } from '../ApplicationValidationSummary';
import styles from './ApplicationValidationScore.module.scss';

type ValidationScoreProps = ScoreProps;

export const ApplicationValidationScore = ({
  value = 0,
  maxValue = 5,
  votes = 0,
  entityType = '',
}: ValidationScoreProps) => {
  const voteText = `${votes} ${votes === 1 ? entityType : entityType + 's'}`;

  return (
    <div className={styles.container}>
      <Amount value={String(value)} measure={`out of ${maxValue}`} size="large" />
      <Typography variant="caption-s" color="tertiary">
        {voteText}
      </Typography>
    </div>
  );
};
